import { ref, computed } from 'vue';
import { useInternationalization } from '@/i18n';

import defaultConfig from '@/config/defaultConfig';

const language = ref(null);
const isLanguageDialogOpen = ref(false);

export const useLanguageSelector = () => {
  const { currentLanguage, loadLanguageAsync, setLanguage } =
    useInternationalization();

  if (!language.value) {
    language.value = currentLanguage.value;
  }

  const formattedSelectedLanguage = computed(() => {
    const found = defaultConfig.i18n.languages.find(
      (lang) => lang.short === language.value
    );
    return found ? found.display.toUpperCase() : 'en';
  });

  const selectLanguage = async (newLocale) => {
    try {
      language.value = newLocale;
      await loadLanguageAsync(newLocale);
      setLanguage(newLocale);
    } catch (error) {
      console.error('Error changing language:', error);
    }
  };

  const setLanguageDialogOpen = (isOpen) => {
    isLanguageDialogOpen.value = isOpen;
  };

  return {
    supportedLanguages: defaultConfig.i18n.languages,
    language,
    isLanguageDialogOpen,
    formattedSelectedLanguage,
    selectLanguage,
    setLanguageDialogOpen
  };
};
